import clsx from 'clsx';
import React from 'react';

interface Feature {
  icon: string;
  alt: string;
  text: string;
}

const features: Feature[] = [
  {
    icon: '/images/data-is-protected.png',
    alt: 'Security Icon',
    text: 'Your data is protected with enterprise-grade security',
  },
  {
    icon: '/images/designed-for-speed.png',
    alt: 'Speed Icon',
    text: 'Designed for speed, accuracy, and ease of use',
  },
  {
    icon: '/images/built-for-accountants.png',
    alt: 'Team Icon',
    text: 'Built for accountants, business owners, and their teams',
  },
  {
    icon: '/images/access-anywhere.png',
    alt: 'Desktop Access Icon',
    text: 'Access anywhere, anytime—best on desktop view',
  },
  {
    icon: '/images/data-is-protected.png',
    alt: 'Communication Icon',
    text: 'Streamlined Communication & Workflow',
  },
];

const FeaturesSection: React.FC = () => {
  return (
    <section
      className={clsx(
        'tw-bg-white',
        'tw-py-10',
        'tw-px-6',
        'lg: tw-my-12',
        'sm:tw-px-6',
        'lg:tw-px-20'
      )}
    >
      <div className="subheading-max-width tw-mx-auto tw-text-center tw-px-6">
        <h2
          className={clsx(
            'tw-text-2xl',
            'sm:tw-text-3xl',
            'tw-font-extrabold',
            'tw-mb-4',
            'tw-mb-6',
            'tw-leading-snug'
          )}
        >
          Smarter Accounting for Stronger Business Growth
        </h2>
        <p
          className={clsx(
            'subheading',
            'tw-text-gray-600',
            'tw-mb-10',
            'tw-mx-auto',
            'tw-text-xl',
            'md:tw-mb-10'
          )}
        >
          CloudCFO Web Application empowers you with secure access, real-time
          insights, and automated processes— helping you streamline finances,
          stay compliant, and make data-driven decisions that fuel growth.
        </p>
      </div>

      <div
        className={clsx(
          'tw-w-full',
          'tw-flex',
          'tw-justify-center',
          'tw-bg-white',
          'tw-py-10',
          'md:tw-md-10'
        )}
      >
        <div
          className={clsx(
            'tw-grid',
            'tw-grid-cols-2',
            'md:tw-grid-cols-5',
            'tw-gap-6',
            'tw-w-full',
            'tw-px-4',
            'md:tw-px-[120px]'
          )}
        >
          {features.map((item) => (
            <div key={item.text} className="tw-text-center">
              <img
                src={item.icon}
                alt={item.alt}
                className={clsx(
                  'tw-mx-auto',
                  'tw-mb-2',
                  'tw-w-20',
                  'md:tw-w-32'
                )}
              />
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
